import { Subscribe, getStaticProps } from '@public/Subscribe'

export { getStaticProps }

export default Subscribe
